import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { Colors } from '../../styles/Variables';

export const SidebarContainer = styled(Box)<{ open: boolean }>`
    background-color: ${Colors.white};
    border-radius: 8px;
    height: calc(100vh - 8px);
    overflow: hidden;
    position: fixed;
    transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    min-width: ${(props) => (props.open ? '240px' : '68px')};
    width: ${(props) => (props.open ? '240px' : '68px')};
    z-index: 1;
`;
